import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RutaCriticaService } from './services/ruta-critica.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-copiar-ruta-dialog',
  templateUrl: './copiar-ruta-dialog.component.html',
  providers: [MessageService]
})
export class CopiarRutaDialogComponent implements OnInit {
  @Output() formResult = new EventEmitter<any>();
  form: FormGroup;
  origenes: { value: number, label: string }[] = [];
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private rutaCriticaService: RutaCriticaService,
    private messageService: MessageService
  ) {
    this.form = this.fb.group({
      origen: [null, Validators.required],
      destino: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.form.reset();
    this.rutaCriticaService.getProcesos().subscribe({
      next: (res) => {
        if (res.success) {
          this.origenes = res.data.map((p: any) => ({
            value: p.numero_Proceso,
            label: `${p.numero_Proceso} | ${p.descriptivo}`
          }));
        }
      }
    });
  }

  aceptar() {
    if (this.form.valid) {
      this.loading = true;
      const payload = {
        que: 6,
        numero_proceso: this.form.get('origen')?.value,
        descripcion: '',
        descriptivo: '',
        duracion: Number(this.form.get('destino')?.value),
        costo: 0
      };
      this.rutaCriticaService.copiarProceso(payload).subscribe({
        next: (res) => {
          if (res.success && res.data.error === '0') {
            this.formResult.emit({success: true, mensaje: 'Ruta copiada correctamente'});
          } else {
            this.formResult.emit({success: false, mensaje: 'No se pudo copiar la ruta'});
          }
        },
        error: () => {
          this.formResult.emit({success: false, mensaje: 'No se pudo copiar la ruta'});
        },
        complete: () => {
          this.loading = false;
        }
      });
    }
  }

  cerrar() {
    this.formResult.emit(null);
  }
} 